import React from 'react';
import { Container } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import image1 from '../img/max.png';
import Image from 'react-bootstrap/Image';

const Dashboard = () => {
    return (
        <div>
            <h1 className='mb-3'>Home</h1>

            <Image src={image1} rounded className='w-100 img-fluid mt-2 mb-2' style={{ maxHeight: '200px' }} />

            <Row className="d-flex justify-content-around">
                <Col sm={12} md={3} className="mb-3">
                    <Card className="shadow-lg">
                        <Card.Body>
                            <Card.Title>Card Title</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>
                            <Card.Text>
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                            </Card.Text>
                            <Card.Link href="#">Card Link</Card.Link>
                            <Card.Link href="#">Another Link</Card.Link>
                        </Card.Body>
                    </Card>
                </Col>

                <Col sm={12} md={3}  className="mb-3">
                    <Card className="shadow-lg">
                        <Card.Body>
                            <Card.Title>Card Title</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>
                            <Card.Text>
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                            </Card.Text>
                            <Card.Link href="#">Card Link</Card.Link>
                            <Card.Link href="#">Another Link</Card.Link>
                        </Card.Body>
                    </Card>
                </Col>

                <Col sm={12} md={3}  className="mb-3">
                    <Card className="shadow-lg">
                        <Card.Body>
                            <Card.Title>Card Title</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>
                            <Card.Text>
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                                Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                            </Card.Text>
                            <Card.Link href="#">Card Link</Card.Link>
                            <Card.Link href="#">Another Link</Card.Link>
                        </Card.Body>
                    </Card>
                </Col>
            </Row >
        </div >
    );
};

export default Dashboard;